// This file is auto gererated by build/build-entry.js
import Actionsheet from './actionsheet';
import AppHeader from './app-header';
import Area from './area';
import Avatar from './avatar';
import Button from './button';
import Calendar from './calendar';
import CalendarDay from './calendar-day';
import CalendarMonth from './calendar-month';
import Cell from './cell';
import CellGroup from './cell-group';
import Checkbox from './checkbox';
import CheckboxGroup from './checkbox-group';
import Col from './col';
import DatetimePicker from './datetime-picker';
import Dialog from './dialog';
import Field from './field';
import Grid from './grid';
import GridItem from './grid-item';
import Icon from './icon';
import Image from './image';
import ImagePreview from './image-preview';
import Lazyload from './lazyload';
import List from './list';
import Loading from './loading';
import NavBar from './nav-bar';
import Overlay from './overlay';
import Picker from './picker';
import Popup from './popup';
import PullRefresh from './pull-refresh';
import Radio from './radio';
import RadioGroup from './radio-group';
import Rate from './rate';
import Row from './row';
import Search from './search';
import Step from './step';
import Stepper from './stepper';
import Sticky from './sticky';
import Swipe from './swipe';
import SwipeCell from './swipe-cell';
import SwipeItem from './swipe-item';
import Switch from './switch';
import SwitchCell from './switch-cell';
import Tab from './tab';
import TabBarBottom from './tab-bar-bottom';
import TabbarItem from './tabbar-item';
import Tabs from './tabs';
import Toast from './toast';
import UnitItem from './unit-item';
import UnitItem2 from './unit-item-2';
import UnitItem3 from './unit-item-3';
import Uploader from './uploader';
import UserAvatar from './user-avatar';
import Verify from './verify';
import Waterfall from './waterfall';
var version = '1.4.47';
var components = [Actionsheet, AppHeader, Area, Avatar, Button, Calendar, CalendarDay, CalendarMonth, Cell, CellGroup, Checkbox, CheckboxGroup, Col, DatetimePicker, Dialog, Field, Grid, GridItem, Icon, Image, ImagePreview, List, Loading, NavBar, Overlay, Picker, Popup, PullRefresh, Radio, RadioGroup, Rate, Row, Search, Step, Stepper, Sticky, Swipe, SwipeCell, SwipeItem, Switch, SwitchCell, Tab, TabBarBottom, TabbarItem, Tabs, Toast, UnitItem, UnitItem2, UnitItem3, Uploader, UserAvatar, Verify];

var install = function install(Vue) {
  components.forEach(function (Component) {
    Vue.use(Component);
  });
};
/* istanbul ignore if */


if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { install, version, Actionsheet, AppHeader, Area, Avatar, Button, Calendar, CalendarDay, CalendarMonth, Cell, CellGroup, Checkbox, CheckboxGroup, Col, DatetimePicker, Dialog, Field, Grid, GridItem, Icon, Image, ImagePreview, Lazyload, List, Loading, NavBar, Overlay, Picker, Popup, PullRefresh, Radio, RadioGroup, Rate, Row, Search, Step, Stepper, Sticky, Swipe, SwipeCell, SwipeItem, Switch, SwitchCell, Tab, TabBarBottom, TabbarItem, Tabs, Toast, UnitItem, UnitItem2, UnitItem3, Uploader, UserAvatar, Verify, Waterfall };
export default {
  install: install,
  version: version
};